/************************************** THIRD-PARTY MODULES ***************************************/
import {action} from 'mobx';
import {switchExpr} from 'mad-utils/lib/react';

/********************************************* EXPORT *********************************************/
/**
 * Abstract store to inherit from
 * Provides data setting mechanism
 * with built-in optional caching in sessionStore
 */
export abstract class BaseStore {

    /**
     * TODO get rid of setData
     *
     * High-level data setter (data meta-setter?)
     * @param {string} dataKey - key in current data store
     * @param {boolean} noCache - Description
     */
    @action
    protected setData = <T = R[S], R = this, S extends keyof R = keyof R>(
        dataKey: S,
        data: T,
        doCache: boolean = true,
        cachePrefix: string = ''
    ): T => {
        (this as any)[dataKey] = data as T;
        if (doCache) {
            const ssKey = cachePrefix ? `${cachePrefix}_${dataKey}` : dataKey;
            sessionStorage.setItem(
                ssKey.toString(),
                switchExpr((data as any) === true, 'true', (data as any) === false, 'false', data)
            );
        }
        return (this as any)[dataKey];
    };
}
